/**
 * The deployment's company name for the screen before sign-in, where no
 * tenant is known yet. It comes from the build (VITE_COMPANY_NAME, set from
 * the repository variable COMPANY_NAME in the deploy workflows), never from
 * the code, so another company's deployment shows its own name. Unset or
 * blank: no name line.
 */
export function signInCompanyName(raw: string | undefined = import.meta.env.VITE_COMPANY_NAME): string | null {
  const name = (raw ?? '').trim();
  return name === '' ? null : name;
}
